export default __webpack_public_path__ + "static/media/arrow.-right.e1714ac9.svg";